import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchSectors, fetchAllCategories, fetchTopCategories } from '../store/actions';
import Header from './Header';
import Footer from './Footer';
import './MainLayout.css';

const MainLayout = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        // Загружаем данные для основного сайта
        dispatch(fetchSectors());
        dispatch(fetchAllCategories());
        dispatch(fetchTopCategories());
    }, [dispatch]);

    return (
        <>
            <Header />
            <div className="content-container">
                <Outlet />
            </div>
            <Footer />
        </>
    );
};

export default MainLayout;